import { render, staticRenderFns } from "./ReviewPrompt.vue?vue&type=template&id=25c80854&scoped=true"
import script from "./ReviewPrompt.vue?vue&type=script&lang=js"
export * from "./ReviewPrompt.vue?vue&type=script&lang=js"
import style0 from "./ReviewPrompt.vue?vue&type=style&index=0&id=25c80854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c80854",
  null
  
)

export default component.exports